module.exports = __webpack_public_path__ + "img/TrustBy_Promed.2498af3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/brochure/professional/TrustBy_Promed.jpg
// module id = 609
// module chunks = 5